import { deleteParent } from '../services/tool';

const initState = {};

export default {
  namespace: 'baseTool',
  state: initState,
  effects: {
    // 获取可以匹配的字段列表
    *fetchDeleteParent({ params, callback }, { call }) {
      try {
        yield call(deleteParent, params);
        if (callback) {
          callback()
        }
      } catch (error) {
        console.error(error)
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    reset() {
      return { ...initState };
    },
  },
};
